import { FC } from 'react';
import { Control, FieldValues, useController } from 'react-hook-form';
import Select from 'react-select';
import { FormErrorMessage } from '../form.styles';
import { countryCodeMapping } from './countryList';
import {
  SelectContainer,
  SelectError,
  selectStyles,
} from './CountrySelect.styles';

export interface Option {
  label: string;
  value: string;
}

const options = Object.entries(countryCodeMapping).map(
  ([countryName, countryCode]) => ({
    value: countryCode,
    label: countryName,
  }),
);

interface Props {
  control: Control<FieldValues>;
}

const CountrySelect: FC<Props> = ({ control }) => {
  const {
    field: {
      value: countryValue,
      onChange: onCountryChange,
      ...restCountryField
    },
    fieldState: { error },
  } = useController({ name: 'country', control, rules: { required: true } });

  const renderedSelect = (
    <SelectContainer>
      <Select<Option>
        {...restCountryField}
        options={options}
        styles={selectStyles}
        placeholder="Select country"
        value={options.find((x) => x.value === countryValue)}
        onChange={(option) => onCountryChange(option?.value)}
      />
    </SelectContainer>
  );

  return error ? (
    <>
      <SelectError>{renderedSelect}</SelectError>
      <FormErrorMessage>This field is required</FormErrorMessage>
    </>
  ) : (
    renderedSelect
  );
};

export default CountrySelect;
